<template lang="pug">
  .car-actions
    .button.interior-exterior(@click="onToggleCabineViewClick",
      v-if="!isMobile",
      ga-category="scene",
      ga-label="interior") {{!insideCabine ? "Интерьер" : "Экстерьер"}}
    .action.trunk(@click="$emit('action', 'trunk')",
      :class="{light: trunkOpened}",
      ga-category="scene",
      ga-label="trunk")
    .action.doors(@click="$emit('action', 'doors')",
      :class="{light: doorsOpened}",
      ga-category="scene",
      ga-label="doors")
    .action.lights(v-if="!insideCabine || this.carModel === 'polo'", @click="$emit('action', 'lights')",
      :class="{light: lightsEnabled}",
      ga-category="scene",
      ga-label="lights")
    .action.ambient-light(v-else, @click="$emit('action', 'ambient-light')",
      :class="{light: ambientLightEnabled}",
      ga-category="scene",
      ga-label="ambientLight")
</template>
<script>
import {mapActions, mapGetters} from "vuex";
import isMobileMixin from "@/components/mixins/isMobileMixin";

export default {
  mixins: [isMobileMixin],
  name: 'CarActions',
  props: ['doorsOpened', 'trunkOpened', 'lightsEnabled', 'ambientLightEnabled'],
  data() {
    return {}
  },

  computed: {
    ...mapGetters(['insideCabine', 'carModel'])
  },
  methods: {
    ...mapActions(['setInsideCabine', 'hideUspWindow']),

    onToggleCabineViewClick() {
      this.hideUspWindow()
      this.setInsideCabine(!this.insideCabine)
    }
  }
}
</script>